var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLeft = function SvgLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.06 4.218 5.277 4.966.027-.024 1.06.998-.027.024.028.026-1.061.998-.027-.026-5.276 4.967L6 15.15l5.276-4.967L6 5.217l1.06-.999Z",
    fill: "#000",
    fillRule: "nonzero"
  })));
};
export default SvgLeft;